// extracted by mini-css-extract-plugin
export var childrenContainer = "_de-0";
export var virtualScrollArea = "_de-1";